// extracted by mini-css-extract-plugin
export var attachment = "_r4-a";
export var emailContainer = "_r4-4";
export var emailContentPaddedContainer = "_r4-b";
export var emailHeader = "_r4-6";
export var emailIframe = "_r4-3";
export var emailInfoIcon = "_r4-9";
export var emailShortenedSummary = "_r4-e";
export var infoDropdown = "_r4-0";
export var infoRowBoundedContent = "_r4-d";
export var internal = "_r4-5";
export var merchant = "_r4-8";
export var messageInputContainer = "_r4-h";
export var normal = "_r4-7";
export var replyCard = "_r4-f";
export var subtleButton = "_r4-1";
export var subtleButtonIconContainer = "_r4-2";
export var toggleViewRepliesButton = "_r4-c";
export var wrappingText = "_r4-g";